// 导入axios实例
import httpRequest from '@/utils/fetch'

export function getIndexAlarmCount () {
  return httpRequest({
    url: '/admin/account/alarm/record/index/query.json',
    method: 'get'
  })
}

export function getAlarmList (param) {
  return httpRequest({
    url: '/admin/account/alarm/record/query.json',
    method: 'get',
    params: param
  })
}

export function handleAlarm (param) {
  return httpRequest({
    url: '/admin/account/alarm/record/set.json',
    method: 'get',
    params: param
  })
}

export function getSelfList (param) {
  return httpRequest({
    url: '/admin/account/self/introduction/query.json',
    method: 'get',
    params: param
  })
}

export function auditSelf (param) {
  return httpRequest({
    url: '/admin/account/self/introduction/audit.json',
    method: 'post',
    data: param
  })
}

export function pushSave (param) {
  return httpRequest({
    url: '/admin/image/content/push/config/save.json',
    method: 'post',
    data: param
  })
}

export function pushQuery (param) {
  return httpRequest({
    url: '/admin/image/content/push/config/query.json',
    method: 'post',
    params: param
  })
}

export function getList (param) {
  return httpRequest({
    url: '/admin/dynamics/list.json',
    method: 'get',
    params: param
  })
}

export function getCommendList (param) {
  return httpRequest({
    url: '/admin/dynamics/getDynamicCommends.json',
    method: 'get',
    params: param
  })
}

export function getDetail (param) {
  return httpRequest({
    url: '/admin/dynamics/' + param.id,
    method: 'get'
  })
}

export function getComment (param) {
  return httpRequest({
    url: '/admin/dynamics/comment.json',
    method: 'get',
    params: param
  })
}

export function deleteComment (param) {
  return httpRequest({
    url: '/admin/dynamics/comment/delete/' + param,
    method: 'get'
  })
}

export function getTopList (param) {
  return httpRequest({
    url: '/admin/dynamics/list/top.json',
    method: 'get',
    params: param
  })
}

export function addTop (dynamicId) {
  return httpRequest({
    url: '/admin/dynamics/top/add.json?dynamicId=' + dynamicId,
    method: 'get'
  })
}

export function deleteUlog (dynamicId) {
  return httpRequest({
    url: `/admin/dynamics/${dynamicId}`,
    method: 'delete'
  })
}

export function hideUlog (param) {
  return httpRequest({
    url: '/admin/dynamics/hide.json',
    method: 'post',
    params: param
  })
}

export function deleteTop (dynamicId) {
  return httpRequest({
    url: `/admin/dynamics/top/remove/${dynamicId}`,
    method: 'get'
  })
}

export function dynamicsCommendAuditCheck (param) {
  return httpRequest({
    url: '/admin/dynamics/audit/comment/check',
    method: 'get',
    params: param
  })
}
